import * as React from 'react'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { LineItemGroupProps } from '../LineItemGroup'
import { Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle } from '@fluentui/react-components'
import { FieldArrayRenderProps } from 'formik/dist/FieldArray'
import { Actions } from './Actions'
import { Body } from './Body'
import { LineItemGroupMutationDto } from '../../../../../../config/finance/invoiceConfig'
import { useTranslation } from 'react-i18next'

type Props = Omit<LineItemGroupProps, 'prefix' | 'isDragging' | 'setCurrentLineItem'> & {
    isNew: boolean
    open: boolean
    setOpen: (open: boolean) => void
}

// Courtesy of https://stackoverflow.com/a/49286056
type UpdateValues = (value: Partial<LineItemGroupMutationDto>) => void

export type LineItemGroupDialogProps = Props & {
    values: LineItemGroupMutationDto
    updateValues: UpdateValues
}

export default function LineItemGroupDialog(props: Props & FieldArrayRenderProps): ReactElement {
    const { t: translate } = useTranslation()

    const [values, setValues] = useState<LineItemGroupMutationDto>()
    const updateValues: UpdateValues = useCallback(
        newValues => {
            setValues(oldValues => ({ ...oldValues, ...newValues }))
        },
        [values],
    )

    useEffect(() => {
        setValues(props.lineItemGroup)
    }, [props.open])

    if (!values) {
        return <></>
    }

    return (
        <Dialog
            open={props.open}
            onOpenChange={(_, data) => {
                if (props.isNew) {
                    props.remove(props.index)
                }
                props.setOpen(data.open)
            }}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{translate(props.isNew ? 'invoice.edit.form.invoicegroup.add' : 'invoice.edit.form.invoicegroup.edit')}</DialogTitle>
                    <DialogContent>
                        <Body {...props} values={values} updateValues={updateValues} />
                    </DialogContent>
                    <Actions {...props} values={values} updateValues={updateValues} />
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}
